import styled, { css } from "styled-components";

type BreakInside = {
    value: "auto" | "avoid" | "avoid-page" | "avoid-column" | "avoid-region";
};

/**
 * breakInsideStyle is an utility component
 */
export const breakInsideStyle = css<BreakInside>`
    break-inside: ${({ value }) => value};
`;

/**
 * PageBreakInside
 */
export const PageBreakInside = styled.div<BreakInside>`
    ${breakInsideStyle};
`;
